import { useEffect, useState } from 'react';
import { api } from '../api';
import { t, type Key } from '../i18n';
import { closeApp } from '../telegram';
import { fmt } from './fmt';

type FamilyCase = {
  id: string;
  number: string;
  origin_country: string | null;
  dest_country: string | null;
  manager: string | null;
  steps: { key: string; reached_at: string | null }[];
};

/** «Моя справа»: кроки справи (фаза 5) і менеджер. «Написати менеджеру» — назад у чат бота. */
export function Family({ caseId }: { caseId: string | null }) {
  const [cases, setCases] = useState<FamilyCase[] | null>(null);
  useEffect(() => {
    api<{ cases: FamilyCase[] }>('/tg/app/family').then((r) => setCases(r.cases)).catch(() => setCases([]));
  }, []);
  if (!cases) return <div className="center">{t('loading')}</div>;
  const c = cases.find((x) => x.id === caseId) ?? cases[0];
  if (!c) return <div className="center">{t('no_case')}</div>;
  const cur = c.steps.findIndex((s) => !s.reached_at);
  const initials = (c.manager ?? '').split(' ').map((x) => x[0]).join('').slice(0, 2).toUpperCase();
  return (
    <div className="app">
      <div className="body">
        <div>
          <div className="k">{t('case')} {c.number}</div>
          <h1 className="h1">{[c.origin_country, c.dest_country].filter(Boolean).join(' → ')}</h1>
        </div>
        <div className="card">
          <div className="lbl">{t('where_now')}</div>
          {c.steps.map((s, i) => (
            <div className="fst" key={s.key}>
              <span className={`fn ${s.reached_at ? 'ok' : i === cur ? 'now' : ''}`}>{s.reached_at ? '✓' : ''}</span>
              <span>{i === cur ? <b>{t(`f_${s.key}` as Key)}</b> : t(`f_${s.key}` as Key)}</span>
              <span className="k">{s.reached_at ? fmt(s.reached_at, true).slice(0, 5) : ''}</span>
            </div>
          ))}
        </div>
        {c.manager && (
          <div className="card">
            <div className="lbl">{t('manager')}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ width: 44, height: 44, borderRadius: '50%', background: '#111', color: '#fff', display: 'flex',
                             alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>{initials}</span>
              <b>{c.manager}</b>
            </div>
          </div>
        )}
      </div>
      <button className="main" type="button" onClick={closeApp}>{t('write_manager')}</button>
    </div>
  );
}
